import gql from 'graphql-tag';

export const GET_UPLOAD_INSTRUCTIONS = gql`
  query (
    $keys: [String!]!
    $serviceId: Int
    $locale: Locale
  ) {
    getTranslations (keys: $keys, serviceId: $serviceId, locale: $locale) {
      locale
      value
    }
  }
`;
